import { motion } from 'framer-motion';

import { STATS } from './learnPracticeBuildData';
import StatCard from './statCard';

const LearnPracticeBuild = () => {
  return (
    <div className="flex flex-col items-center bg-white sm:py-20 sm:px-[120px] py-[60px] px-5 gap-10">
      <div className="flex flex-col items-center gap-1 w-full max-w-[1200px]">
        <motion.div
          className="w-full text-[24px] leading-[30px] sm:text-[40px] sm:leading-[52px] tracking-[0.02em] sm:tracking-[0.04em] text-center text-[#020617] font-gilroy-bold"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          Everything You Need to Learn, Practice &amp; Build!
        </motion.div>
        <motion.div
          className="w-full text-[14px] leading-[18px] sm:text-[16px] sm:leading-[22px] tracking-[0.02em] text-center text-[#020617] font-[Gilroy-Regular]"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.15, ease: 'easeOut' }}
        >
          Get structured learning with expert-led lectures, coding practice, assignments and real-world projects
        </motion.div>
      </div>
      <div className="flex flex-col items-center gap-10 w-full max-w-[1200px]">
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-10 sm:gap-y-14 w-full">
          {STATS.slice(0, 3).map((stat) => (
            <StatCard key={stat.label} {...stat} />
          ))}
        </div>
        <div className="flex flex-wrap items-end justify-center gap-x-10 gap-y-10 sm:gap-y-14 w-full">
          {STATS.slice(3, 5).map((stat) => (
            <StatCard key={stat.label} {...stat} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LearnPracticeBuild;
